import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import mutation from "../../../containers/modules/mutation/mutation";

export default function MutationRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="mutation"
      index
      element={
        <AccessControl
          name={"Mutation List"}
          auth={authUser}
          component={mutation}
        />
      }
    />
  );
}
